import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Navbar from "../components/Navbar";
import FooterSection from "../components/home/FooterSection";
import { Timeline } from "../components/ui/timeline";
import { MagicText } from "../components/ui/magic-text";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ChecklistIcon from "@mui/icons-material/Checklist";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const TimelinePage = () => {
  const timelineData = [
    {
      title: "Warm Introduction",
      icon: <WavingHandIcon />,
      content: (
        <MagicText
          text="We'll kick things off with an introduction to EduTools - who we are, what we stand for, and how we help organizations like yours create healthy, thriving, long lasting foundations for their chapter."
        />
      ),
    },
    {
      title: "Dedicated Representative",
      icon: <SupportAgentIcon />,
      content: (
        <MagicText
          text="Here, you'll be assigned an EduTools representative who will be by your side throughout the entire process. They will serve as your primary point of contact and answer any questions, ensuring everything is seamless, clear, and tailored."
        />
      ),
    },
    {
      title: "Private Executive Demo",
      icon: <PlayCircleOutlineIcon />,
      content: (
        <MagicText
          text="Enjoy a walkthrough and complementary week long demo of the platform. Where you'll be able to use it yourself, ask questions, and give feedback. So we can ensure your experience is fine-tuned to your organization's goals, needs, and priorities."
        />
      ),
    },
    {
      title: "Next Steps",
      icon: <ChecklistIcon />,
      content: (
        <MagicText
          text="This is where we collaborate with your team to talk through how EduTools would look like within your organization, covering goals, logistics, and timelines, while answering any more questions along the way."
        />
      ),
    },
    {
      title: "Moving Forward",
      icon: <RocketLaunchIcon />,
      content: (
        <MagicText
          text="This is where we come together to decide whether you'd like to implement EduTools into your organization. From here, our team works with you to handle onboarding and implementation, with hands-on support to ensure a smooth and successful launch."
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#ffffff",
        color: "#000000",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <Navbar />

      <Container
        maxWidth="lg"
        sx={{
          pt: { xs: 14, md: 18 },
          pb: 4,
          px: { xs: 2, md: 4 },
        }}
      >
        {/* Page Header - with extra spacing for scroll room before timeline */}
        <Box sx={{ textAlign: "center", maxWidth: "800px", mx: "auto", mb: { xs: 12, md: 20 }, minHeight: { xs: "30vh", md: "40vh" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.25rem", md: "3.5rem" },
              fontWeight: 700,
              mb: 3,
              color: "#000000",
              lineHeight: 1.1,
              letterSpacing: "-0.02em",
            }}
          >
            Our Journey Together
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.25rem" },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
            }}
          >
            Here's what to expect when partnering with EduTools.
          </Typography>
        </Box>
      </Container>

      {/* Timeline Component */}
      <Timeline data={timelineData} />

      <div style={{ backgroundColor: "#0f0f0f" }}>
        <FooterSection />
      </div>
    </Box>
  );
};

export default TimelinePage;
